import React from 'react';

const Title = () => {
  return (
    <div>
      <div className="title">
      {/* <h1>FireGram</h1> */}
      <h2>Your Pictures</h2>
      <p>Upload your Pictures here</p>
    </div>
    </div>
    
  )
}

export default Title;